module.exports = __webpack_public_path__ + "static/media/sign-out-alt.2fa8c9e3.svg";